import(/* webpackMode: "eager" */ "/poc-codegiant/app/globals.css");
import(/* webpackMode: "eager" */ "/poc-codegiant/components/sentry-provider.tsx");
import(/* webpackMode: "eager" */ "/poc-codegiant/components/theme-provider.tsx");
import(/* webpackMode: "eager" */ "/poc-codegiant/components/ui/toaster.tsx");
import(/* webpackMode: "eager" */ "/poc-codegiant/components/ui/tooltip.tsx")